function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import Base from './base';
import RegistrationInfo from './registration_info';
import $ from 'jquery';
import URI from 'urijs';

var Presenter = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Presenter, _Base);

  function Presenter() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Presenter.prototype;

  _proto.initialize = function initialize(options) {
    var _this = this;

    this.registrationInfo = new RegistrationInfo(options);
    return this.on('change:login', function (model, login) {
      return _this.updateLogin(login);
    });
  };

  _proto.url = function url() {
    return URI('/api/users').segment(this.get('login')).toString();
  };

  _proto.updateLogin = function updateLogin(login) {
    // blow away any existing registration info
    this.registrationInfo.clear(); // reset the login

    return this.registrationInfo.set({
      login: login
    });
  };

  _proto.fetch = function fetch(opts) {
    if (opts === void 0) {
      opts = {};
    }

    this.updateLogin(this.get('login'));
    return $.when(_Base.prototype.fetch.call(this, opts), this.registrationInfo.fetch(opts));
  };

  return Presenter;
}(Base);

export { Presenter as default };